module.exports = __webpack_public_path__ + "static/media/spa.3417ee34.svg";